import React, { useState, useRef } from 'react';
import PropTypes from 'prop-types';
import { Message } from 'antd';
import katex from 'katex';
import { fetchOCR } from '../../api/demonstration';
import FunctionDemonstration from './FunctionDemonstration';
import { getBase64Image } from '@/common/utils/utils';
import 'katex/dist/katex.min.css';
import account from '@/common/account/index';

const OcrPtrDemonstration = ({ materialsPath, selectList }) => {
  const [result, setResult] = useState([]);
  const refResultEle = useRef(null);
  const [response, setReponse] = useState(null);
  const [request] = useState({
    Params: {
      sid: '请求标识',
      URL: '图片的URL地址',
      imagedata: '图片的Base64编码',
      imageLength: '图片的Base64编码的长度'
    }
  });

  // 是否是公式
  const checkIsKatex = (arr) => {
    let isKatexArr = arr.filter((item) => item && /\$/g.test(item.texts));
    return isKatexArr.length > 0;
  };

  // 获取ocr识别出的text结果 类型是 Araay<string||null>
  const getOcrContent = (data) => {
    if (!data) return [];
    let isKatex = checkIsKatex(data) || false;
    let contentArray = data.map((item) => {
      const { texts } = item;
      if (isKatex) {
        let katexDomValue = katex.renderToString(
          texts.replace(/(\$)|#/g, '') || '',
          {
            displayMode: true,
            throwOnError: false,
            errorColor: '#042044',
            strict: 'ignore'
          }
        );
        return katexDomValue;
      } else {
        return `<span class='ocr-content-text'>${texts.replace(
          /(\$)|#/g,
          ''
        )}</span>`;
      }
    });
    return contentArray;
  };

  const analysisImg = (imgBase64, param, isUrl = false) => {
    /**
     * 原文科/理科 转 学科
     * 0 数学
     * 1 语文
     * */
    const OPEN_MODE_TO_SUBJECT = {
      0: 'science',
      1: 'liberat'
    };
    let userId = null;
    const loginEd = account.hasLoggedin();
    if (loginEd) userId = localStorage.getItem('userId') || null;
    const ocrParams = {
      subject: OPEN_MODE_TO_SUBJECT[param],
      method: '/aiimage/comeducation',
      userId
    };
    if (isUrl) {
      ocrParams.image_url = imgBase64;
    } else {
      ocrParams.image_base64 = imgBase64.replace(/\S*base64,/, '');
    }
    fetchOCR(ocrParams)
      .then((data) => {
        const { code, data: { result: resultData = null } = {} } = data;
        setReponse(data);
        if (code === 20000) {
          let content = getOcrContent(resultData).join('');
          setResult(content);
        }
      })
      .catch((err) => {
        Message.error(err.msg || err.message);
        setReponse({});
      });
  };

  const handleImgurlToBase64 = (imgurl, param) => {
    const image = new Image();
    image.setAttribute('crossOrigin', 'anonymous');
    image.src = imgurl;
    image.onload = () => {
      const imgBase64 = getBase64Image(image);
      analysisImg(imgBase64, param);
    };
  };

  const identifyingImg = (imgurl, imgBase64, param) => {
    if (imgurl) {
      // handleImgurlToBase64(imgurl, param);
      analysisImg(imgurl, param, true);
    } else if (imgBase64) {
      analysisImg(imgBase64, param, false);
    }
  };

  return (
    <FunctionDemonstration
      result={
        <ul>
          <li
            className="ptr_result_text"
            ref={refResultEle}
            // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML={{ __html: result || '<span></span>' }}
          />
        </ul>
      }
      response={response}
      request={request}
      handleIdentifyingImg={identifyingImg}
      materialsPath={materialsPath}
      selectList={selectList}
    />
  );
};

OcrPtrDemonstration.propTypes = {
  data: PropTypes.shape({
    materialsPath: PropTypes.array,
    selectList: PropTypes.array
  })
};

export default OcrPtrDemonstration;
